<template>
    <b-modal
        v-model="modal"
        :id="'calendar-add-calendar-item'"
        :title="$t('calendar.new_event')"
        modal-class="apprentice-default-modal"
        size="md"
        @show="onShow"
        @ok="onOk"
        :cancel-title="$t('common.cancel')"
        cancel-variant="outline-primary"
        :ok-disabled="!title || !startDate"
        :ok-title="$t('common.save')">
        <b-alert
            v-if="hasErrors"
            show
            variant="danger">
            {{ errorMessage }}
        </b-alert>

        <div class="title">
            <b-form-group :label="$t('common.title') + ':'">
                <template v-slot:label> {{ $t('common.title') }}: <span class="required">*</span></template>
                <b-form-input
                    id="input-1"
                    v-model="title"
                    required
                    :placeholder="$t('calendar.title')">
                </b-form-input>
            </b-form-group>
        </div>

        <div
            class="description"
            :class="description === placeholderText && 'placeholder-visible'">
            <b-form-group :label="$t('common.description')">
                <ckeditor
                    v-model="description"
                    :editor="editor"
                    :config="editorConfig"
                    @focus="clearPlaceholder"
                    @blur="showPlaceholder"
                    :placeholder="$t('common.description')">
                </ckeditor>
            </b-form-group>
        </div>

        <div class="location">
            <b-form-group :label="$t('common.location')">
                <b-form-input
                    id="input-2"
                    v-model="location"
                    required
                    :placeholder="$t('common.location')"></b-form-input>
            </b-form-group>
        </div>

        <div class="dates">
            <div class="start-date-time">
                <b-form-group :label="$t('calendar.start_date')">
                    <template v-slot:label> {{ $t('calendar.start_date') }} <span class="required">*</span></template>

                    <b-input-group>
                        <b-input-group-append>
                            <b-form-datepicker
                                class="apprentice-date-picker btn-date-group"
                                v-model="startDate"
                                start-weekday="1"
                                now-button
                                reset-button
                                right
                                today-variant="primary"
                                nav-button-variant="primary"
                                locale="nl"
                                :aria-controls="$t('calendar.choose_date')"
                                label-reset-button="reset"
                                :label-no-date-selected="$t('calendar.no_date_selected')"
                                menu-class="datedropdown"
                                :date-format-options="{
                                    year: 'numeric',
                                    month: 'short',
                                    day: '2-digit',
                                    weekday: 'short',
                                }"></b-form-datepicker>
                        </b-input-group-append>
                    </b-input-group>
                </b-form-group>

                <b-form-group :label="$t('calendar.end_date')">
                    <b-input-group>
                        <b-input-group-append>
                            <b-form-datepicker
                                class="apprentice-date-picker btn-date-group"
                                v-model="endDate"
                                start-weekday="1"
                                now-button
                                reset-button
                                right
                                today-variant="primary"
                                nav-button-variant="primary"
                                locale="nl"
                                :aria-controls="$t('calendar.choose_date')"
                                label-reset-button="Reset"
                                :label-no-date-selected="$t('calendar.no_date_selected')"
                                menu-class="datedropdown"
                                :date-format-options="{
                                    year: 'numeric',
                                    month: 'short',
                                    day: '2-digit',
                                    weekday: 'short',
                                }"
                                :initial-date="getMinDate"
                                :min="getMinimumRequiredDate">
                            </b-form-datepicker>
                        </b-input-group-append>
                    </b-input-group>
                </b-form-group>
            </div>

            <div class="end-date-time">
                <b-form-group :label="$t('calendar.start_time')">
                    <design-2021-apprentice-timepicker-component
                        v-model="startTime"></design-2021-apprentice-timepicker-component>
                </b-form-group>

                <b-form-group :label="$t('calendar.end_time')">
                    <design-2021-apprentice-timepicker-component
                        v-model="endTime"></design-2021-apprentice-timepicker-component>
                </b-form-group>
            </div>
        </div>
    </b-modal>
</template>

<script>
import ApprenticeEditor from '../../../helpers/ApprenticeEditor';
import $ from 'jquery';

export default {
    name: 'design-2021-calendar-add-calendar-item-modal-component',
    data() {
        return {
            modal: false,
            title: null,
            placeholderText: `<p>${this.$t('calendar.fill_in_the_description')}</p>`,
            description: `<p>${this.$t('calendar.fill_in_the_description')}</p>`,
            location: null,
            startDate: null,
            startTime: null,
            endDate: null,
            endTime: null,
            editor: ApprenticeEditor,
            editorConfig: {
                contentsCss: 'test',
                bodyClass: 'mybodyclass',
                toolbar: {
                    items: [
                        'heading',
                        '|',
                        'bold',
                        'italic',
                        'underline',
                        '|',
                        'link',
                        'bulletedList',
                        'numberedList',
                        'undo',
                        'redo',
                    ],
                },
                language: this.$authUser.locale,
                table: {
                    contentToolbar: ['tableColumn', 'tableRow', 'mergeTableCells'],
                },
                hasErrors: false,
                errorMessage: '',
            },
        };
    },
    methods: {
        onOk(bvModal) {
            if (!this.isFormValidated()) {
                bvModal.preventDefault();
                $('.apprentice-default-modal').animate({ scrollTop: 0 }, 500);
                return;
            }

            let data = {
                title: this.title,
                description: this.description === this.placeholderText ? null : this.description,
                location: this.location,
                startDate: this.startDate,
                startTime: this.startTime,
                endDate: this.endDate,
                endTime: this.endTime,
            };
            this.$emit('create-agenda-item', data);
        },

        onShow() {
            this.title = null;
            this.description = this.placeholderText;
            this.location = null;
            this.startDate = null;
            this.startTime = null;
            this.endDate = null;
            this.endTime = null;
            this.hasErrors = false;
            this.errorMessage = this.$t('calendar.error_not_all_required_fields_set');

            this.modal = true;
        },

        clearPlaceholder() {
            if (this.description === this.placeholderText) {
                this.description = '';
            }
        },

        showPlaceholder() {
            if (this.description === '') {
                this.description = this.placeholderText;
            }
        },

        isFormValidated() {
            this.hasErrors =
                this.title === '' || this.title === null || this.startDate === '' || this.startDate === null;

            if (!this.hasErrors && this.startDate === this.endDate && this.startTime === this.endTime) {
                this.hasErrors = true;
                this.errorMessage = this.$t('calendar.error_start_end_not_equal');
            }

            if (!this.hasErrors && this.startDate === this.endDate && this.endTime < this.startTime) {
                this.hasErrors = true;
                this.errorMessage = this.$t('calendar.error_end_time_before_start_time');
            }

            return !this.hasErrors;
        },
    },

    computed: {
        getMinDate() {
            let minRequiredDate = this.startDate !== '' ? new Date(this.startDate) : new Date();
            minRequiredDate.setMonth(minRequiredDate.getDay() + 1);
            return minRequiredDate;
        },

        getMinimumRequiredDate() {
            return this.startDate !== '' ? new Date(this.startDate) : new Date();
        },
    },
};
</script>

<style scoped lang="scss">
input.form-control {
    margin-bottom: 0;
}

.dates {
    display: flex;
    flex: 1;
    flex-direction: row;
    flex-wrap: wrap;
    align-items: center;

    .apprentice-date-picker {
        margin-bottom: 0;
    }

    .start-date-time,
    .end-date-time {
        flex: 1 0 100%;

        .input-group-append {
            width: inherit;
        }

        .apprentice-default-time-picker ::v-deep {
            input {
                margin-bottom: 0;
            }
        }
    }
}

@media (min-width: map-get($grid-breakpoints, 'sm')) {
    .dates {
        .start-date-time {
            flex: 1;
            margin-right: 30px;

            .input-group-append {
                width: inherit;
            }
        }

        .end-date-time {
            flex: 0 0 200px;
        }
    }
}
</style>
